export const asLocalTime = (dateString?: string) => {
  if (!dateString) return '';

  return new Date(dateString.replace(/Z$/, '')).toISOString();
};
